<template>
  <div>
    <!--微信-->
    <Wepay v-if="payType === 20" :payInfo=payInfo></Wepay>
    <!--支付宝-->
    <Alipay v-else-if="payType === 30" :payInfo=payInfo></Alipay>
    <!--拉卡拉-->
    <Lakala v-else-if="payType === 40" :payInfo=payInfo></Lakala>
  </div>

</template>

<script>
import Alipay from "./part/Alipay.vue";
import Lakala from "./part/Lakala.vue";
import Wepay from "./part/Wepay.vue";
import moment from 'moment'

export default {
  computed: {
    payType() {
      return parseInt(this.$route.query.applymentType, 10);
    },
    payInfo() {
      return {timeStamp: moment().unix(), applymentId: this.$route.query.applymentId, op: this.$route.query.op};
    },
  },
  components: {
    Wepay,
    Lakala,
    Alipay,
  },
  data() {
    return {
      loading: false,
    };
  },
  created() {

  },
  watch: {},
  mounted() {

  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/setting/applyment/edit.vue